export default function HomePage() {
  return <div></div>;
}
